/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AccountBannerItem from './AccountBannerItem';
import AccountProofProperty from './AccountProofProperty';
import AccountThemeSettings from './AccountThemeSettings';
import AshoreUserRole from './AshoreUserRole';
import AshoreUsersTeam from './AshoreUsersTeam';
import EmailSendData from './EmailSendData';
import Subscription from './Subscription';
import SubscriptionState from './SubscriptionState';

/**
 * The Account model module.
 * @module model/Account
 * @version V1
 */
class Account {
    /**
     * Constructs a new <code>Account</code>.
     * @alias module:model/Account
     */
    constructor() { 
        
        Account.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>Account</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Account} obj Optional instance to populate.
     * @return {module:model/Account} The populated <code>Account</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Account();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('resellerId')) {
                obj['resellerId'] = ApiClient.convertToType(data['resellerId'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('whiteLabelDomainName')) {
                obj['whiteLabelDomainName'] = ApiClient.convertToType(data['whiteLabelDomainName'], 'String');
            }
            if (data.hasOwnProperty('whiteLabelLogoUri')) {
                obj['whiteLabelLogoUri'] = ApiClient.convertToType(data['whiteLabelLogoUri'], 'String');
            }
            if (data.hasOwnProperty('noReplyEmail')) {
                obj['noReplyEmail'] = ApiClient.convertToType(data['noReplyEmail'], 'String');
            }
            if (data.hasOwnProperty('lastLogin')) {
                obj['lastLogin'] = ApiClient.convertToType(data['lastLogin'], 'Date');
            }
            if (data.hasOwnProperty('timeZone')) {
                obj['timeZone'] = ApiClient.convertToType(data['timeZone'], 'String');
            }
            if (data.hasOwnProperty('countryCode')) {
                obj['countryCode'] = ApiClient.convertToType(data['countryCode'], 'String');
            }
            if (data.hasOwnProperty('timeZoneId')) {
                obj['timeZoneId'] = ApiClient.convertToType(data['timeZoneId'], 'String');
            }
            if (data.hasOwnProperty('dateFormat')) {
                obj['dateFormat'] = ApiClient.convertToType(data['dateFormat'], 'String');
            }
            if (data.hasOwnProperty('emailPolicy')) {
                obj['emailPolicy'] = ApiClient.convertToType(data['emailPolicy'], 'Number');
            }
            if (data.hasOwnProperty('timeZoneOffSet')) {
                obj['timeZoneOffSet'] = ApiClient.convertToType(data['timeZoneOffSet'], 'Number');
            }
            if (data.hasOwnProperty('currentSubscriptionSku')) {
                obj['currentSubscriptionSku'] = ApiClient.convertToType(data['currentSubscriptionSku'], 'String');
            }
            if (data.hasOwnProperty('subscriptionState')) {
                obj['subscriptionState'] = SubscriptionState.constructFromObject(data['subscriptionState']);
            }
            if (data.hasOwnProperty('banners')) {
                obj['banners'] = ApiClient.convertToType(data['banners'], [AccountBannerItem]);
            }
            if (data.hasOwnProperty('subscription')) {
                obj['subscription'] = Subscription.constructFromObject(data['subscription']);
            }
            if (data.hasOwnProperty('accountProofProperties')) {
                obj['accountProofProperties'] = ApiClient.convertToType(data['accountProofProperties'], [AccountProofProperty]);
            }
            if (data.hasOwnProperty('emailSettings')) {
                obj['emailSettings'] = ApiClient.convertToType(data['emailSettings'], [EmailSendData]);
            }
            if (data.hasOwnProperty('usersTeams')) {
                obj['usersTeams'] = ApiClient.convertToType(data['usersTeams'], [AshoreUsersTeam]);
            }
            if (data.hasOwnProperty('accountRoles')) {
                obj['accountRoles'] = ApiClient.convertToType(data['accountRoles'], [AshoreUserRole]);
            }
            if (data.hasOwnProperty('themeSettings')) {
                obj['themeSettings'] = AccountThemeSettings.constructFromObject(data['themeSettings']);
            }
            if (data.hasOwnProperty('defaultProofEmailTemplateId')) {
                obj['defaultProofEmailTemplateId'] = ApiClient.convertToType(data['defaultProofEmailTemplateId'], 'Number');
            }
            if (data.hasOwnProperty('defaultNewVersionEmailTemplateId')) {
                obj['defaultNewVersionEmailTemplateId'] = ApiClient.convertToType(data['defaultNewVersionEmailTemplateId'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Account</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Account</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['whiteLabelDomainName'] && !(typeof data['whiteLabelDomainName'] === 'string' || data['whiteLabelDomainName'] instanceof String)) {
            throw new Error("Expected the field `whiteLabelDomainName` to be a primitive type in the JSON string but got " + data['whiteLabelDomainName']);
        }
        // ensure the json data is a string
        if (data['whiteLabelLogoUri'] && !(typeof data['whiteLabelLogoUri'] === 'string' || data['whiteLabelLogoUri'] instanceof String)) {
            throw new Error("Expected the field `whiteLabelLogoUri` to be a primitive type in the JSON string but got " + data['whiteLabelLogoUri']);
        }
        // ensure the json data is a string
        if (data['noReplyEmail'] && !(typeof data['noReplyEmail'] === 'string' || data['noReplyEmail'] instanceof String)) {
            throw new Error("Expected the field `noReplyEmail` to be a primitive type in the JSON string but got " + data['noReplyEmail']);
        }
        // ensure the json data is a string
        if (data['timeZone'] && !(typeof data['timeZone'] === 'string' || data['timeZone'] instanceof String)) {
            throw new Error("Expected the field `timeZone` to be a primitive type in the JSON string but got " + data['timeZone']);
        }
        // ensure the json data is a string
        if (data['countryCode'] && !(typeof data['countryCode'] === 'string' || data['countryCode'] instanceof String)) {
            throw new Error("Expected the field `countryCode` to be a primitive type in the JSON string but got " + data['countryCode']);
        }
        // ensure the json data is a string
        if (data['timeZoneId'] && !(typeof data['timeZoneId'] === 'string' || data['timeZoneId'] instanceof String)) {
            throw new Error("Expected the field `timeZoneId` to be a primitive type in the JSON string but got " + data['timeZoneId']);
        }
        // ensure the json data is a string
        if (data['dateFormat'] && !(typeof data['dateFormat'] === 'string' || data['dateFormat'] instanceof String)) {
            throw new Error("Expected the field `dateFormat` to be a primitive type in the JSON string but got " + data['dateFormat']);
        }
        // ensure the json data is a string
        if (data['currentSubscriptionSku'] && !(typeof data['currentSubscriptionSku'] === 'string' || data['currentSubscriptionSku'] instanceof String)) {
            throw new Error("Expected the field `currentSubscriptionSku` to be a primitive type in the JSON string but got " + data['currentSubscriptionSku']);
        }
        // validate the optional field `subscriptionState`
        if (data['subscriptionState']) { // data not null
          SubscriptionState.validateJSON(data['subscriptionState']);
        }
        if (data['banners']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['banners'])) {
                throw new Error("Expected the field `banners` to be an array in the JSON data but got " + data['banners']);
            }
            // validate the optional field `banners` (array)
            for (const item of data['banners']) {
                AccountBannerItem.validateJSON(item);
            };
        }
        // validate the optional field `subscription`
        if (data['subscription']) { // data not null
          Subscription.validateJSON(data['subscription']);
        }
        if (data['accountProofProperties']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['accountProofProperties'])) {
                throw new Error("Expected the field `accountProofProperties` to be an array in the JSON data but got " + data['accountProofProperties']);
            }
            // validate the optional field `accountProofProperties` (array)
            for (const item of data['accountProofProperties']) {
                AccountProofProperty.validateJSON(item);
            };
        }
        if (data['emailSettings']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['emailSettings'])) {
                throw new Error("Expected the field `emailSettings` to be an array in the JSON data but got " + data['emailSettings']);
            }
            // validate the optional field `emailSettings` (array)
            for (const item of data['emailSettings']) {
                EmailSendData.validateJSON(item);
            };
        }
        if (data['usersTeams']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['usersTeams'])) {
                throw new Error("Expected the field `usersTeams` to be an array in the JSON data but got " + data['usersTeams']);
            }
            // validate the optional field `usersTeams` (array)
            for (const item of data['usersTeams']) {
                AshoreUsersTeam.validateJSON(item);
            };
        }
        if (data['accountRoles']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['accountRoles'])) {
                throw new Error("Expected the field `accountRoles` to be an array in the JSON data but got " + data['accountRoles']);
            }
            // validate the optional field `accountRoles` (array)
            for (const item of data['accountRoles']) {
                AshoreUserRole.validateJSON(item);
            };
        }
        // validate the optional field `themeSettings`
        if (data['themeSettings']) { // data not null
          AccountThemeSettings.validateJSON(data['themeSettings']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
Account.prototype['id'] = undefined;

/**
 * @member {Number} resellerId
 */
Account.prototype['resellerId'] = undefined;

/**
 * @member {String} name
 */
Account.prototype['name'] = undefined;

/**
 * @member {String} whiteLabelDomainName
 */
Account.prototype['whiteLabelDomainName'] = undefined;

/**
 * @member {String} whiteLabelLogoUri
 */
Account.prototype['whiteLabelLogoUri'] = undefined;

/**
 * @member {String} noReplyEmail
 */
Account.prototype['noReplyEmail'] = undefined;

/**
 * @member {Date} lastLogin
 */
Account.prototype['lastLogin'] = undefined;

/**
 * @member {String} timeZone
 */
Account.prototype['timeZone'] = undefined;

/**
 * @member {String} countryCode
 */
Account.prototype['countryCode'] = undefined;

/**
 * @member {String} timeZoneId
 */
Account.prototype['timeZoneId'] = undefined;

/**
 * @member {String} dateFormat
 */
Account.prototype['dateFormat'] = undefined;

/**
 * @member {Number} emailPolicy
 */
Account.prototype['emailPolicy'] = undefined;

/**
 * @member {Number} timeZoneOffSet
 */
Account.prototype['timeZoneOffSet'] = undefined;

/**
 * @member {String} currentSubscriptionSku
 */
Account.prototype['currentSubscriptionSku'] = undefined;

/**
 * @member {module:model/SubscriptionState} subscriptionState
 */
Account.prototype['subscriptionState'] = undefined;

/**
 * @member {Array.<module:model/AccountBannerItem>} banners
 */
Account.prototype['banners'] = undefined;

/**
 * @member {module:model/Subscription} subscription
 */
Account.prototype['subscription'] = undefined;

/**
 * @member {Array.<module:model/AccountProofProperty>} accountProofProperties
 */
Account.prototype['accountProofProperties'] = undefined;

/**
 * @member {Array.<module:model/EmailSendData>} emailSettings
 */
Account.prototype['emailSettings'] = undefined;

/**
 * @member {Array.<module:model/AshoreUsersTeam>} usersTeams
 */
Account.prototype['usersTeams'] = undefined;

/**
 * @member {Array.<module:model/AshoreUserRole>} accountRoles
 */
Account.prototype['accountRoles'] = undefined;

/**
 * @member {module:model/AccountThemeSettings} themeSettings
 */
Account.prototype['themeSettings'] = undefined;

/**
 * @member {Number} defaultProofEmailTemplateId
 */
Account.prototype['defaultProofEmailTemplateId'] = undefined;

/**
 * @member {Number} defaultNewVersionEmailTemplateId
 */
Account.prototype['defaultNewVersionEmailTemplateId'] = undefined;






export default Account;

